import {
  FetchResult,
  gql,
  MutationFunctionOptions,
  useMutation,
} from "@apollo/client"

const MUTATION_UPDATE_PLAYBACK_TIMING = gql`
  mutation UpdatePlaybackTiming(
    $position: Float = 0
    $velocity: Float = 0
  ) {
    updatePlaybackTiming(position: $position, velocity: $velocity) {
      position
      velocity
    }
  }
`

interface UpdatePlaybackTimingVariables {
  position?: number
  velocity?: number
}

interface UpdatePlaybackTimingData {
  updatePlaybackTiming: {
    position?: number
    velocity?: number
  }
}

export const useUpdatePlaybackTiming = (): ((
  options: MutationFunctionOptions<
    UpdatePlaybackTimingData,
    UpdatePlaybackTimingVariables
  >,
) => Promise<FetchResult<UpdatePlaybackTimingData>>) => {
  const [mutate] = useMutation<
    UpdatePlaybackTimingData,
    UpdatePlaybackTimingVariables
  >(MUTATION_UPDATE_PLAYBACK_TIMING)

  return mutate
}
